const hasTextInside = (htmlString) => {
    const textContent = htmlString?.replace(/<[^>]*>/g, '').trim();
    return !!textContent; // Trả về true nếu chuỗi không rỗng, ngược lại trả về false
}

export default hasTextInside;